export default __webpack_public_path__ + "static/media/dino_showroom_160xtb_kori.affd5721.jpg";